import { collection, getDocs, query, where } from 'firebase/firestore';
import { firestore } from 'services';
import { strings } from 'strings';
import * as yup from 'yup';

export enum EditCollectionField {
  Name = 'name',
  Keywords = 'keywords',
  AdminOnly = 'adminOnly',
}

export const editCollectionSchema = (currentCollectionId: string) =>
  yup.object().shape({
    [EditCollectionField.Name]: yup
      .string()
      .required(strings.createAccNameRequired)
      .trim()
      .min(3, 'Must have atleast 3 characters!')
      .max(50, 'Cant have more than 50 characters!')
      .test(
        'mustContainOnly',
        'Must contain only uppercase, lowercase letters, numbers and space!',
        (value) => {
          const match = value?.match?.(/[a-zA-Z 0-9]*/)?.[0];
          return Boolean(match && match?.length === value.length);
        },
      )
      .test('uniqueName', 'Name must be unique', async (value) => {
        const collectionsQuery = query(
          collection(firestore, 'collections'),
          where('name', '==', value.trim()),
        );
        const isEmpty =
          (await getDocs(collectionsQuery))?.docs?.filter((doc) => doc?.id !== currentCollectionId)
            ?.length == 0;
        return isEmpty;
      }),
    [EditCollectionField.Keywords]: yup.string().trim().required('Keywords is required'),
    [EditCollectionField.AdminOnly]: yup.boolean(),
  });
